function handleChooseKamar() {
    const listKamar = $("#kamar .custom-card");

    listKamar.on("click", function () {
        let choosedKamar =
            listKamar[$(listKamar).index(this)].attributes.value.value;

        for (let i = 0; i < listKamar.length; i += 1) {
            if (listKamar[i].attributes.value.value === choosedKamar) {
                listKamar[i].classList.add("active");
            } else {
                listKamar[i].classList.remove("active");
            }
        }

        handleKamarItem(choosedKamar);
        handlePerlengkapanItem(choosedKamar);
    });
}

const handleKamarItem = (val) => {
    const vvip = $("#vvip");
    const vipA = $("#vipA");
    const vipB = $("#vipB");
    const vipDeluxe = $("#vipDeluxe");

    if (val == 0) {
        vvip.toggle(true);
        vipA.toggle(false);
        vipB.toggle(false);
        vipDeluxe.toggle(false);
    } else if (val == 1) {
        vvip.toggle(false);
        vipA.toggle(true);
        vipB.toggle(false);
        vipDeluxe.toggle(false);
    } else if (val == 2) {
        vvip.toggle(false);
        vipA.toggle(false);
        vipB.toggle(true);
        vipDeluxe.toggle(false);
    } else if (val == 3) {
        vvip.toggle(false);
        vipA.toggle(false);
        vipB.toggle(false);
        vipDeluxe.toggle(true);
    }
};

const handlePerlengkapanItem = (val) => {
    const perlengkapanItem = $("#perlengkapan-item");

    if (val == 0) {
        perlengkapanItem.toggle(true);
    } else {
        perlengkapanItem.toggle(false);
    }
};

const kamarSlider = (id) => {

    new Swiper(`#${id}`, {
        speed: 400,
        loop: true,
        centeredSlides: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        slidesPerView: "auto",
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
        },
    });
};

const kamarLightBox = GLightbox({
    selector: '.kamar-lightbox'
  });

module.exports = { 
    handleChooseKamar, 
    kamarSlider, 
    //kamarLightBox 
};
